<template>
    <span class="icon" v-b-tooltip.hover.html="{ title: content, placement: position, boundary: 'viewport' }">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask :id="id" :fill="maskColor">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11ZM6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"/>
            </mask>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11ZM6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z" :fill="color"/>
            <path d="M9.5 6C9.5 7.933 7.933 9.5 6 9.5V12.5C9.58985 12.5 12.5 9.58985 12.5 6H9.5ZM6 2.5C7.933 2.5 9.5 4.067 9.5 6H12.5C12.5 2.41015 9.58985 -0.5 6 -0.5V2.5ZM2.5 6C2.5 4.067 4.067 2.5 6 2.5V-0.5C2.41015 -0.5 -0.5 2.41015 -0.5 6H2.5ZM6 9.5C4.067 9.5 2.5 7.933 2.5 6H-0.5C-0.5 9.58985 2.41015 12.5 6 12.5V9.5ZM10.5 6C10.5 8.48528 8.48528 10.5 6 10.5V13.5C10.1421 13.5 13.5 10.1421 13.5 6H10.5ZM6 1.5C8.48528 1.5 10.5 3.51472 10.5 6H13.5C13.5 1.85786 10.1421 -1.5 6 -1.5V1.5ZM1.5 6C1.5 3.51472 3.51472 1.5 6 1.5V-1.5C1.85786 -1.5 -1.5 1.85786 -1.5 6H1.5ZM6 10.5C3.51472 10.5 1.5 8.48528 1.5 6H-1.5C-1.5 10.1421 1.85786 13.5 6 13.5V10.5Z" fill="#C2CAD8" :mask="mask"/>
            <path d="M5.33334 3.30506C5.33334 2.87947 5.55556 2.66667 6 2.66667C6.44445 2.66667 6.66667 2.87947 6.66667 3.30506C6.66667 3.50786 6.61044 3.66639 6.49799 3.78064C6.38822 3.89204 6.22222 3.94773 6 3.94773C5.55556 3.94773 5.33334 3.73351 5.33334 3.30506ZM6.61044 9.33334H5.38554V4.54328H6.61044V9.33334Z" :fill="color"/>
        </svg>
    </span>
</template>

<script>
export default {
    name: 'tooltip',
    props: {
        content: {
            type: String,
        },
        color: {
            default: '#C2CAD8',
            type: String,
        },
        maskColor: {
            default: 'white',
            type: String,
        },
        position: {
            type: String,
            default: 'top',
            validator: value => {
                return ['top', 'topleft', 'topright', 'right', 'righttop', 'rightbottom', 'bottom', 'bottomleft', 'bottomright', 'left', 'lefttop', 'leftbottom' ].includes(value);
            }
        }
    },
    computed: {
        id() {
            return this._uid;
        },
        mask() {
            return "url(#"+this.id+")";
        }
    }
}
</script>
<style lang="scss" scoped>
:deep(.tooltip-inner) {
    word-break: break-word;
}
</style>
